module.exports = __webpack_public_path__ + "static/media/invitationSvg.fd479ae8.svg";